import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import getFulfillRefundDataActions from '../../../../redux/actions/fulfillRefund';
import TranslatedCopy from '../../../intl/translated-copy';
import useWizard from '../wizard/useWizard';
import PropTypes from 'prop-types';
import cx from 'classnames';

const RefundFooter = ({
  dispatch,
  documentNumbers,
  fulfillRefundData,
  handleShowModal,
  isAwEligible,
  isFopEligible,
  isSignIn,
  loadingFulfillRefund,
  loginRequired = false,
  optionSelected,
  pnrInfo,
  quoteRefundData,
  radioChange,
  refundCode96Dot5,
}) => {
  const cancelLinkClasses = cx({
    'RefundFooter-content-cancelLinkDisabled': loadingFulfillRefund,
    'RefundFooter-content-cancelLink': !loadingFulfillRefund,
  });

  // Variables
  const { handleNextStep, isLastPage, quotationsToRender, setCancelRefundModal, setSpecialRefundModal, step } = useWizard();
  const signInValidation = isSignIn || !loginRequired;

  const stepOneCard = step === 1 && optionSelected === 'Card';
  const stepOneAw = step === 1 && optionSelected === 'AW';

  const hasFops = pnrInfo?.cart?.travelerCollection?.some(
    (t) => t?.formOfPayment && t?.formOfPayment.length > 0
  ) || quoteRefundData?.fops?.length > 0;

  const [refundOptionSelected, setRefundOptionSelected] = useState(hasFops ? '1' : '2');
  const refundAmount = (quotationsToRender || []).reduce((sum, quotation) => {
    return sum + (quotation?.quoteItemAmount?.dAmount || 0);
  }, 0);
  const hasSelectedPassengers = documentNumbers.length > 0;
  const shouldShowConfirmModal = refundAmount > 0;
  const disablePrimaryRefundAction = loadingFulfillRefund || !hasSelectedPassengers;
  const disableSameFopRefundAction = disablePrimaryRefundAction || !hasFops;

  // Methods
  const handleContinue = () => {
    const email = pnrInfo?.cart?.travelerCollection?.[0]?.email;
    const name = pnrInfo?.cart?.travelerCollection?.[0]?.displayName;
    const ticketNumber = pnrInfo?.cart?.travelerCollection?.[0]?.ticketNumber;
    if (step === 0 && (!isSignIn && loginRequired)) {
      handleShowModal();
    } else if (step === 0 && signInValidation) {
      handleNextStep();
    } else if (step === 1 && signInValidation) {
      dispatch(getFulfillRefundDataActions(email, name, ticketNumber, documentNumbers, refundCode96Dot5));
    }
  };

  const refundOptionFunction = () => {
    const checkedElementValue = document.querySelector('input[name="refundOption"]:checked').value;
    setRefundOptionSelected(checkedElementValue);
  };

  const handleConfirmModalOrContinue = () => {
    if (shouldShowConfirmModal) {
      setSpecialRefundModal(true);
      return;
    }

    handleContinue();
  };

  // useEffect
  useEffect(() => {
    if (step === 2 && (!isSignIn && loginRequired) && !fulfillRefundData) {
      window.location.replace('/');
    }
    if (fulfillRefundData) {
      handleNextStep();
    }
  }, [fulfillRefundData, isSignIn]);
  return (step !== 2 &&
    <>
      { step === 0 &&
        <section className='RefundFooter'>
          <div className='RefundFooter-right'>
            <button
              disabled={ ((radioChange || isLastPage) && (isAwEligible && isFopEligible) || loadingFulfillRefund) }
              onClick={ () => handleContinue() }
              className='RefundFooter-stepBtn'
            >
              <TranslatedCopy copyID='CONTINUE' />
            </button>
          </div>
        </section>
      }
      { stepOneCard &&
        <section className='RefundFooter'>
          <div className='RefundFooter-options' onClick={ () => refundOptionFunction() }>
            <label className={ `RefundFooter-options-radio ${ !hasFops ? 'RefundFooter-options-radio--disabled' : '' }` }>
              <TranslatedCopy
                copyID='MYB_REFUND_TO_THE_SAME_PAYMENT_METHOD'
              />
              <input
                defaultChecked={ hasFops ? 'checked' : undefined }
                disabled={ !hasFops }
                id='option1'
                name='refundOption'
                type='radio'
                value={ 1 }
              />
              <span className='RefundFooter-options-checkmarkFooter' />
            </label>
            <label className='RefundFooter-options-radio'>
              <TranslatedCopy
                copyID='MYB_REFUND_TO_ANOTHER_PAYMENT_METHOD'
              />
              <input
                defaultChecked={ !hasFops ? 'checked' : undefined }
                id='option2'
                name='refundOption'
                type='radio'
                value={ 2 }
              />
              <span className='RefundFooter-options-checkmarkFooter' />
            </label>
          </div>
          <div className='RefundFooter-content'>
            <TranslatedCopy
              className={ cancelLinkClasses }
              copyID='MYB_CANCEL_REFUND'
              onClick={ () => setCancelRefundModal(true) }
            />
            { refundOptionSelected === '1' &&
              <>
                <button
                  className='RefundFooter-stepBtn'
                  disabled={ disableSameFopRefundAction }
                  onClick={ () => handleConfirmModalOrContinue() }
                >
                  <TranslatedCopy copyID='MYB_ACCEPT_REFUND' />
                </button>
                { !hasFops &&
                  <TranslatedCopy
                    className='RefundFooter-content-errorMessage'
                    copyID='MYB_NO_VALID_FOP'
                    tagName='p'
                  />
                }
              </>
            }
            { refundOptionSelected === '2' &&
              <button
                className='RefundFooter-stepBtn'
                disabled={ disablePrimaryRefundAction }
                onClick={ () => handleConfirmModalOrContinue() }
              >
                <TranslatedCopy copyID='MYB_REQUEST_SPECIAL_REFUND_FINAL' />
              </button>
            }
          </div>
        </section>
      }
      { stepOneAw &&
        <section className='RefundFooter'>
          <div className='RefundFooter-content'>
            <TranslatedCopy
              className={ cancelLinkClasses }
              copyID='MYB_CANCEL_REFUND'
              onClick={ () => setCancelRefundModal(true) }
            />
            <button
              disabled={ ((radioChange || isLastPage) && (isAwEligible && isFopEligible) || loadingFulfillRefund) }
              onClick={ () => handleConfirmModalOrContinue() }
              className='RefundFooter-stepBtn'
            >
              <TranslatedCopy copyID='MYB_ACCEPT_REFUND' />
            </button>
          </div>
        </section>
      }
    </>
  );
};

RefundFooter.propTypes = {
  dispatch: PropTypes.func,
  fulfillRefundData: PropTypes.object,
  handleClickOnStepZero: PropTypes.func,
  handleShowModal: PropTypes.func,
  isAwEligible: PropTypes.bool,
  isFopEligible: PropTypes.bool,
  isMobile: PropTypes.bool,
  isSignIn: PropTypes.bool,
  loadingFulfillRefund: PropTypes.bool,
  optionSelected: PropTypes.string,
  params: PropTypes.object,
  pnrInfo: PropTypes.object,
  refundCode96Dot5: PropTypes.bool,
  radioChange: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  documentNumbers: state.refundPassengerList.documentNumbers,
  fulfillRefundData: state?.fulfillRefund?.fulfillRefundData,
  isSignIn: state?.UserProfileSession?.isSignIn,
  loadingFulfillRefund: state?.fulfillRefund?.loadingFulfillRefund,
  loginRequired: state.Manage.stateStoreFront.loginRequired,
  pnrInfo: state.Manage.pnrInfo,
  quoteRefundData: state?.quoteRefund?.quoteRefundData,
  refundCode96Dot5: state.refundCode96Dot5.refundCode96Dot5,
});

export default connect(mapStateToProps)(RefundFooter);

